import { BottomSheet } from '@xing-com/bottom-sheet';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { SEARCH_ALERTS_MODAL_TYPES } from '@xing-com/crate-jobs-constants';
import { useBreakpoints, useSearchAlert } from '@xing-com/crate-jobs-hooks';

import { LIContent, LOContent } from './content';

export const MobileBottomSheet: React.FC = () => {
  const {
    searchQueryId,
    activeParam,
    isQuerySaved,
    isModalActive,
    onClose,
    onCreate,
  } = useSearchAlert();
  const { isMediaSmallOrTiny } = useBreakpoints();
  const { isLoggedIn } = useLoginState();

  const isActive = isModalActive([
    SEARCH_ALERTS_MODAL_TYPES.CREATE,
    SEARCH_ALERTS_MODAL_TYPES.REPEAT,
  ]);

  return (
    <BottomSheet show={isActive && isMediaSmallOrTiny} onOutsideClick={onClose}>
      {isLoggedIn ? (
        <LIContent
          disabled={!searchQueryId}
          isQuerySaved={isQuerySaved}
          onCreate={onCreate}
          onClose={onClose}
        />
      ) : (
        <LOContent type={activeParam} onClose={onClose} />
      )}
    </BottomSheet>
  );
};
